/**
 * B.H. Copyright (c) 2026 Yemot HaMashiach Ltd.
 * All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * Yemot HaMashiach Ltd. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with Yemot HaMashiach Ltd.
 *
 * Unauthorized copying of this file, via any medium, is strictly prohibited.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getBlockListPolicy } from '../Helper';
import '../styles.css';

// הערות משותפות לכל טופסי "הוספת מספר לרשימת חסימה" (רשימת הקהילה / קטגוריה / מנוי):
//   1. הסבר קבוע על מספרים ספציפיים מול טווחים ותבנית בינלאומית.
//   2. הערת מגבלת מדיניות (מוצגת רק כשהקהילה מוגבלת לכיוון/סטטוס מסוים).
// אסימונים ספרתיים בטקסט ההסבר עטופים ב-LTR כדי שהכוכבית תופיע בסוף המספר כראוי גם בהקשר RTL.
export default function BlockNumberNotes() {
  const { t } = useTranslation();
  const policy = getBlockListPolicy();

  const restricted = policy.direction !== 'BOTH' || policy.status !== 'BOTH';
  const parts = [];
  if (policy.direction === 'IN') parts.push(t('block_policy_only_in'));
  else if (policy.direction === 'OUT') parts.push(t('block_policy_only_out'));
  if (policy.status === 'OPEN') parts.push(t('block_policy_only_open'));
  else if (policy.status === 'BLOCKED') parts.push(t('block_policy_only_blocked'));

  // האסימונים הספרתיים מסומנים בטקסט התרגום ב-⟪…⟫ ומוחלפים כאן ב-span עם dir="ltr".
  const noteSegments = t('block_range_note').split(/(⟪[^⟫]*⟫)/g);

  return (
    <>
      <div className="bl-note bl-note--info">
        {noteSegments.map((seg, i) => (
          seg.length > 1 && seg[0] === '⟪' && seg[seg.length - 1] === '⟫'
            ? <span key={i} dir="ltr" className="bl-ltr">{seg.slice(1, -1)}</span>
            : <React.Fragment key={i}>{seg}</React.Fragment>
        ))}
      </div>
      {restricted && (
        <div className="bl-note bl-note--policy">
          {t('block_policy_restricted', { parts: parts.join(t('block_policy_and')) })}
        </div>
      )}
    </>
  );
}
